export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('click', event => {
            if (!event.target.matches('a')) {
                const rowLink = event.target
                    .closest('tr')
                    .querySelector('[href]');
                if (rowLink) {
                    rowLink.click();
                }
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/linkedTbodyRow.js